import {DefaultLanguage} from '@/locale'

const getters = {
  isInitialized: state => {
    return state.isInitialized ? state.isInitialized : false
  },
  isLoading: state => {
    return state.isLoading ? state.isLoading : false
  },
  locale: state => {
    return state.locale ? state.locale : DefaultLanguage
  },
  lastPath: state => {
    return state.lastPath ? state.lastPath : null
  },
  apiVersion: state => {
    return state.apiVersion ? state.apiVersion : false
  }
}

export default getters
